import { Injectable } from "@angular/core";
import { CalcConstants } from "../constants/calculate-formate-constant";

@Injectable()
export class CalculateInputFormateService {
  emissionLevelConfig: JSON;

  constructor() {}

  public getInputListQuestionWise(activity, activityId, pillarName) {
    const inputListQuestionWise = [];
    const questionList = activity.questionList;
    questionList.forEach(question => {
      const questionDetails: any = {};
      if (question.commonActivity && question.commonActivity.flag) {
        const commonActivity = {
          flag: question.commonActivity.flag,
          commonPillars: this.getCommonActivityPillars(
            question.inputList,
            question.commonActivity.commonPillars
          )
        };

        questionDetails.commonActivity = commonActivity;
      }

      questionDetails.pillarName = pillarName;
      questionDetails.id = activityId;
      if (question.hasSpatialLandAndOcean) {
        const landAndOceanConfig = question.hasSpatialLandAndOcean;
        const inp = question.inputList.find(
          (obj) => obj.inputControlID === landAndOceanConfig.baseInput
        );
        questionDetails["hasSpatialLand"] = this.hasBothLandandOcean(landAndOceanConfig.spatialLandValue, inp);
        questionDetails["hasSpatialOcean"] = this.hasBothLandandOcean(landAndOceanConfig.spatialOceanValue, inp);
      } else {
        questionDetails["hasSpatialLand"] = question.hasSpatialLand
          ? true
          : false;
        questionDetails["hasSpatialOcean"] = question.hasSpatialOcean
          ? true
          : false;
      }
      questionDetails["landControl"] = question.landControl;
      questionDetails.inputList = this.getQuestionInputList(
        question.inputList,
        activity["qusType"]
      );

      if (question.status !== CalcConstants.delete) {
        inputListQuestionWise.push(questionDetails);
      }
    });
    return inputListQuestionWise;
  }

  private hasBothLandandOcean(spatialvalue, inp){
    if(typeof(spatialvalue) === "string"){
      return inp && inp.ans === spatialvalue ? true : false;
    } else {
      return inp && spatialvalue.some(sv => sv === inp.ans);
    }
  }

  private getQuestionInputList(jsonQuestionArr, qnType) {
    const inputList = [];
    let sortedInputList = Object.assign([], jsonQuestionArr);
    sortedInputList = this.getSortInputList(sortedInputList);

    const emissionArr = [];
    sortedInputList.forEach(inputObj => {
      if (inputObj.type) {
        if (inputObj.type === "dropdown-multiple" && !(qnType && qnType === "special1"))  {
          if (!this.emissionLevelConfig) {
            this.emissionLevelConfig = (
              this.getEmissionLevelConfigJson(inputObj.values)
            ) as JSON;
          }
          const level = this.getEmissionLevel(inputObj.ans);

          inputList.push({
            inputId : inputObj.inputControlID,
            ans: level
          })
        } else {
          inputList.push({
            inputId : inputObj.inputControlID,
            ans: inputObj.ans
          })
        }
      }
    });
    return inputList;
  }

  private getSortInputList(inputList) {
    inputList.sort((a, b) => {
      return a.inputControlID.localeCompare(b.inputControlID);
    });
    return inputList;
  }

  private getCommonActivityPillars(inputList, commonPillars) {
    const pillarWiseInput = [];
    commonPillars.forEach(pillar => {
      const pillarDetails = Object.assign({}, pillar);
      pillarDetails.percentage = this.getInputValue(
        pillar.inputId,
        inputList
      );
      pillarWiseInput.push(pillarDetails);
    });
    return pillarWiseInput;
  }

  private getInputValue(inputId, inputList) {
    let ans = "";
    inputList.forEach(input => {
      if (input.type) {
        if (input.inputControlID === inputId) {
          ans = input.ans;
        }
      }
    });
    return ans;
  }

  private getEmissionLevelConfigJson(values) {
    const emissionLevelJson = {};
    values.forEach(obj => {
      emissionLevelJson[obj.value] = obj.emissionLevel;
    });
    return emissionLevelJson;
  }

  private getEmissionLevel(selectedList) {
    let level = CalcConstants.low;
    selectedList.forEach(value => {
      if (this.emissionLevelConfig[value] === CalcConstants.high) {
        level = CalcConstants.high;
      }
    });
    return level;
  }
}
